import type { InvitationRepository } from '@zetyar/data-contracts'
import { createSupabaseInvitationRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webInvitationRepository: InvitationRepository = createSupabaseInvitationRepository(getSupabaseClient())
